import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="IMDB Movie Reviews Sentiment Analysis (Classification)" link="https://github.com/Hongyanlee0614/Python-Data-Science/tree/main/IMDB%20Movie%20Reviews" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  - Compared the performance of 2 machine learning models (Logistic Regression
  and Multinomial Naive Bayes) and achieved roughly 86% accuracy and F1 score in
  predicting new movie review sentiments
      <p>{`Tools: Google Colab, Python, Pandas, Numpy, Matplotlib, Seaborn, NLTK, Sklearn, BeautifulSoup`}</p>
    </ProjectCard>
    <ProjectCard title="Life Expectancy Shiny Web App (Regression)" link="https://hongyanlee.shinyapps.io/WIE2003_Intro_to_Data_Science/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  - Developed a shiny web app in R to predict life expectancy of people based on their lifestyles and country factors. Used regression algorithm to model a relationship between strong predictor features and life expectancy
      <p>{`Tools: R, R Shiny, Ggplot2, Tidyverse`}</p>
    </ProjectCard>
    <ProjectCard title="Automated Google Form Filling (Automation)" link="https://github.com/Hongyanlee0614/Automated-Form-Filling/blob/main/automation.py" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  - Wrote a Python script template to automate the task of Google Form filling which is annoying especially in WhatsApp
      <p>{`Tools: Python, Selenium`}</p>
    </ProjectCard>
    <ProjectCard title="YouTube Video Downloads Assistant" link="https://github.com/Hongyanlee0614/Web-Scraping-For-Fun/blob/main/youtube.py" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  - Created a Python script to download YouTube videos easily from the internet (suitable for developer only)
      <p>{`Tools: Python`}</p>
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      